<template>
  <ConfigProvider :locale="getAntdLocale">
    <AppProvider>
      <RouterView />
    </AppProvider>
  </ConfigProvider>
  <GlobalNewFeatureNotification />
  <Proxy></Proxy>
</template>

<script lang="ts" setup>
  import { ref, onMounted } from 'vue';
  import { ConfigProvider } from 'ant-design-vue';
  import { AppProvider } from '/@/components/Application';
  import { useTitle } from '/@/hooks/web/useTitle';
  import { useLocale } from '/@/locales/useLocale';
  import Proxy from '/@/components/aproxy/index.vue'
  import { handleTofixedPrecision } from '/@/views/project/project.util'
  import { GlobalNewFeatureNotification } from '/@/ecnComponents/featureNotification/index';

  // support Multi-language
  const { getAntdLocale } = useLocale();

  useTitle();
  handleTofixedPrecision();
</script>

